var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgramPlayTab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 28,
    viewBox: "0 0 170 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_524_14724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.81094 0L0 2.74117L11.5105 14L0 25.2521L2.81094 28L17.1256 14L2.81094 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6786 0L10.8745 2.74117L22.385 14L10.8745 25.2521L13.6786 28L28 14L13.6786 0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_524_14724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.4828 1.6084H55.326V26.3848H59.4828V1.6084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8118 1.6084H66.655V26.3848H70.8118V1.6084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4753 11.2157L56.7353 15.2344L58.0777 19.1812L69.8176 15.1625L68.4753 11.2157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6017 1.6416H36V5.81181H50.6017V1.6416Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3826 3.72656H41.2257V26.3582H45.3826V3.72656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6613 28L73.6886 13.1461L82.8337 0L86.2383 2.38298L78.8022 13.0733L88 25.5177L84.6613 28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3307 11.0283H76.2487V15.1985H86.3307V11.0283Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_524_14724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.177 26.9906L141.6 8.42924L135.39 26.9563L131.271 25.5491L139.482 1.04311L141.3 1.02938L143.595 1.00879L152.276 25.5148L148.177 26.9906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.798 19.3998L141.779 16.3564L138.76 19.3998L141.779 22.4432L144.798 19.3998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.854 28V0H119.205V21.6985L126.981 18.8017L128.492 22.9203L114.854 28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.351 27.7735H96V0.226562L112.498 9.43176L100.399 22.2614L100.351 22.2133V27.7735ZM100.351 7.6676V15.9461L105.464 10.5232L100.351 7.6676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.228 16.7076L152.283 2.24425L156.198 0.335938L161.169 10.6875L166.071 0.342802L170 2.23738L163.15 16.6939L159.228 16.7076Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.314 14.1338H158.963V27.6636H163.314V14.1338Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_524_14724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_524_14724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 28,
    fill: "white",
    transform: "translate(36)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_524_14724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 28,
    fill: "white",
    transform: "translate(96)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramPlayTab);
export default __webpack_public_path__ + "static/media/programPlayTab.7d2030618cd99256efcf2d2acaddb784.svg";
export { ForwardRef as ReactComponent };